import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';
import { Star, ArrowRight, Shield, TrendingUp, Gift } from 'lucide-react';

const reviews = [
  {
    id: 'netbet',
    name: 'NetBet',
    url: 'https://www.netbet.fr/',
    bonus: 'Bonus de bienvenue de 100€',
    description: 'Une plateforme reconnue avec une sélection impressionnante de paris sportifs et des cotes compétitives.',
    rating: 4.5,
    icon: Shield,
    color: 'from-blue-600 to-blue-800',
    image: '/images/john-fornander-y6_SJpU3Alk-unsplash.webp',
  },
  {
    id: 'unibet',
    name: 'UniBet',
    url: 'https://www.unibet.fr/',
    bonus: '10€ de dépôt gratuit + 100€ de bonus',
    description: 'Démarrez votre expérience sans risquer un centime avec une offre exclusive pour nouveaux parieurs.',
    rating: 4.7,
    icon: TrendingUp,
    color: 'from-green-600 to-green-800',
    image: '/images/eduard-labar-9lOrwiZ3W4k-unsplash.webp',
  },
  {
    id: 'vbet',
    name: 'Vbet',
    url: 'https://vbet.fr/',
    bonus: 'Bonus de bienvenue de 100€',
    description: 'Un opérateur de confiance avec des années d\'expérience et des promotions régulières.',
    rating: 4.6,
    icon: Gift,
    color: 'from-purple-600 to-purple-800',
    image: '/images/peter-glaser-qWs_Wa1JrKM-unsplash.webp',
  },
];

const Reviews = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Avis Détaillés des Meilleurs Sites de Paris",
    "description": "Des analyses approfondies et honnêtes des sites de paris français les plus populaires, testés en conditions réelles",
    "url": "https://galo-bet.com/reviews",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": reviews.map((review, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": review.name,
        "url": `https://galo-bet.com/reviews/${review.id}`
      }))
    }
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <SEO 
        title="Avis Détaillés"
        description="Des analyses approfondies et honnêtes des sites de paris français les plus populaires. Testés en conditions réelles pour vous guider dans vos choix."
        jsonLd={jsonLd}
      />
      <Header />
      <main className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            {/* Hero Section */}
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                <span className="bg-gradient-to-r from-pink-400 to-pink-600 bg-clip-text text-transparent">
                  Avis Détaillés
                </span>
                <br />
                <span className="text-white">Des Meilleurs Sites de Paris</span>
              </h1>
              <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                Des analyses approfondies et honnêtes des sites de paris français les plus populaires, testés en conditions réelles
              </p>
            </div>

            {/* Reviews Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              {reviews.map((review) => {
                const Icon = review.icon;
                return (
                  <Link
                    key={review.id}
                    to={`/reviews/${review.id}`}
                    data-discover="true"
                    className="group bg-gray-800 rounded-xl overflow-hidden border border-gray-700 hover:border-pink-600 transition-all transform hover:-translate-y-2 flex flex-col"
                  >
                    {/* Image */}
                    <div className="h-48 relative overflow-hidden">
                      <img 
                        src={review.image} 
                        alt={review.name} 
                        className="w-full h-full object-cover"
                      />
                      <div className={`absolute inset-0 bg-gradient-to-br ${review.color} opacity-80`}></div>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <Icon className="text-white opacity-40" size={64} />
                      </div>
                      <div className="absolute top-4 right-4">
                        <div className="bg-black/60 backdrop-blur-sm px-3 py-1 rounded-full flex items-center space-x-1">
                          <Star className="text-yellow-400 fill-yellow-400" size={16} />
                          <span className="text-white text-sm font-semibold">{review.rating}</span>
                        </div>
                      </div>
                    </div>

                    <div className="p-6 flex-1 flex flex-col">
                      <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-pink-400 transition-colors">
                        {review.name}
                      </h3>

                      <div className="mb-3">
                        <p className="text-pink-400 font-semibold text-sm mb-2">{review.bonus}</p>
                      </div>

                      <p className="text-gray-400 text-sm mb-4 flex-1 leading-relaxed">
                        {review.description}
                      </p>

                      <div className="inline-flex items-center space-x-2 text-pink-400 hover:text-pink-300 font-semibold text-sm group/link">
                        <span>Lire l'avis complet</span>
                        <ArrowRight size={16} className="group-hover/link:translate-x-1 transition-transform" />
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Reviews;

